import { Stack, Tabs, TextInput } from '@mantine/core';

import { DrawerTemplateView } from '../drawer-template';
import type { DetailDrawerViewProps } from './DetailDrawer.types';

export function DetailDrawerView({
  opened,
  onClose,
  position = 'right',
  icon,
  iconColor,
  titleValue,
  onTitleChange,
  titlePlaceholder,
  menu,
  size = 'xl',
  loading = false,
  topContent,
  tabs,
  activeTab,
  onTabChange,
  footer,
}: DetailDrawerViewProps) {
  return (
    <DrawerTemplateView
      opened={opened}
      onClose={onClose}
      position={position}
      icon={icon}
      iconColor={iconColor}
      size={size}
      loading={loading}
      footer={footer}
      menu={menu}
      title={
        <TextInput
          value={titleValue}
          onChange={(e) => onTitleChange(e.currentTarget.value)}
          placeholder={titlePlaceholder}
          variant="unstyled"
          styles={{ input: { fontWeight: 600, padding: 0, height: 'auto' } }}
        />
      }
    >
      <Stack gap="lg">
        {topContent}

        <Tabs value={activeTab} onChange={(v) => onTabChange(v ?? tabs[0]?.value)}>
          <Tabs.List mb="md">
            {tabs.map(({ value, label, icon: TabIcon }) => (
              <Tabs.Tab key={value} value={value} leftSection={TabIcon && <TabIcon size={14} />}>
                {label}
              </Tabs.Tab>
            ))}
          </Tabs.List>

          {tabs.map(({ value, content }) => (
            <Tabs.Panel key={value} value={value}>
              {content}
            </Tabs.Panel>
          ))}
        </Tabs>
      </Stack>
    </DrawerTemplateView>
  );
}
